const months = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export interface OrganizationCoverage {
  name: string;
  users: number;
  percentage: number | null;
}

/** Unknown report contracts remain unavailable; missing fields are not zeros. */
export function summarizeCoverage(
  rows: unknown,
  year: number,
  now = new Date(),
): OrganizationCoverage[] {
  if (!Array.isArray(rows)) throw new Error('Formato de reporte no reconocido');
  const monthCount = year < now.getFullYear() ? 12 : now.getMonth() + 1;
  const groups = new Map<
    string,
    { ids: Set<string>; values: number[]; unavailable: boolean }
  >();
  for (const row of rows) {
    if (!row || typeof row !== 'object' || typeof row.user_id !== 'string')
      throw new Error('Formato de reporte no reconocido');
    const name =
      typeof row.organization_name === 'string' && row.organization_name.trim()
        ? row.organization_name
        : 'Sin organización';
    const group = groups.get(name) || {
      ids: new Set<string>(),
      values: [],
      unavailable: false,
    };
    if (group.ids.has(row.user_id))
      throw new Error('Usuarios duplicados en el reporte');
    group.ids.add(row.user_id);
    for (const month of months.slice(0, monthCount)) {
      const raw = row[`${month}_completion`];
      const value =
        typeof raw === 'number'
          ? raw
          : typeof raw === 'string' && raw.trim() !== ''
            ? Number(raw)
            : NaN;
      if (!Number.isFinite(value) || value < 0 || value > 100)
        group.unavailable = true;
      else group.values.push(value);
    }
    groups.set(name, group);
  }
  return Array.from(groups, ([name, group]) => ({
    name,
    users: group.ids.size,
    percentage: group.unavailable
      ? null
      : group.values.reduce((sum, value) => sum + value, 0) /
        group.values.length,
  })).sort((a, b) => a.name.localeCompare(b.name, 'es'));
}
